import {FormField} from './types';

export const isActiveFormField = (formField?: FormField) => !!formField?.is_active;

export const isRequiredFormField = (formField?: FormField) => !!formField?.is_required;

export const isVisibleFormField = (formField?: FormField, isLeaderGuest?: boolean) => {
  if (!isActiveFormField(formField)) return false;
  if (!formField?.is_leaders_field) return true;

  return isRequiredFormField(formField) || Boolean(isLeaderGuest);
};
